import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Grid, Typography, Avatar, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home as HomeIcon, LocationCity, LocationOn, MailOutline } from '@mui/icons-material';
import useServices from '../../services/useServices';
import moment from 'moment';
import makeStyles from '@mui/styles/makeStyles';
import { getSessionData } from '../../utils/utils';

const useStyles = makeStyles({
    labelName: {
        fontWeight: "600",
        marginBottom: "8px",
    },
    valueStyle: {
        marginBottom: "15px !important",
    },
    card: {
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        marginBottom: "16px",
    },
    avatar: {
        width: "60px",
        height: "60px",
        marginBottom: "8px",
    },
    userName: {
        fontWeight: "600",
    },
    userInfo: {
        display: "flex",
        alignItems: "center",
        marginBottom: "8px",
    },
    address: {
        marginBottom: "8px",
    },
    postalCode: {
        marginBottom: "8px",
    },
});

const steps = [
    {
        label: "Request Sent",
        status: "requestTime",
        class: "requested",
        description: null
    },
    {
        label: "Request Accepted",
        status: "acceptedTime",
        class: "accepted",
        description: null

    },
    {
        label: "Onroute",
        status: "enrouteTime",
        class: "onroute",
        description: null
    },
    {
        label: "Arrived",
        status: "arrivedTime",
        class: "arrived",
        description: null
    }
];
const Home = () => {
    const navigate = useNavigate();
    const classes = useStyles();
    const { get } = useServices();
    const [showTrackingDetailsID, setShowTrackingDetailsID] = useState();
    const [requestDetails, setRequestDetails] = useState({});
    const [trackingData, setTrackingData] = useState(JSON.parse(JSON.stringify(steps)));
    const [isLoading, setIsLoading] = useState(false);
    const [userData, setUserData] = useState({});

    var ourRequest = useRef(null)
    const gotoNewRequest = () => {
        navigate("/newrequest")
    }
    const serviceOrders = getSessionData('serviceOrders')
    const serviceRequestNumbers = serviceOrders ? JSON.parse(serviceOrders) : []

    const showTrackingDetails = (id) => {

        setTrackingData(JSON.parse(JSON.stringify(steps)))
        if (id === showTrackingDetailsID) {
            setShowTrackingDetailsID(0)
        } else {
            setIsLoading(true)
            setShowTrackingDetailsID(id)
        }
    }
    const setTrackingDetailsData = () => {
        trackingData.map(item => {
            const dateTime = requestDetails[item.status]
            item.description = dateTime ? 'At ' + moment(dateTime).format('HH:mm:ss MM/DD/YYYY') : dateTime
            return item
        })
        setTrackingData(JSON.parse(JSON.stringify(trackingData)))
        setIsLoading(false)
    }
    useEffect(() => {
        const data = getSessionData("userData") || JSON.stringify({})
        setUserData(JSON.parse(data))
    }, [])
    useEffect(() => {
        setTrackingDetailsData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestDetails])
    useEffect(() => {
        const userID = getSessionData("userID")
        if (!userID) {
           // navigate("/unauthorizedUser")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const gotoTrackOrder = () => {
        navigate("/trackOrder")
    }
    return (
        <>
            <Box sx={{ flexGrow: 1, padding: 3, backgroundColor: '#f5f5f5' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} container justifyContent="space-between" alignItems="center">
                        <Button variant="contained" onClick={gotoTrackOrder}>Track Order</Button>
                        <Button variant="contained" color="success" onClick={gotoNewRequest}>New Request</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper elevation={3} className={classes.card}>
                            <Box className={classes.userInfo}>
                                <Avatar alt="User Avatar" src="/path/to/your/avatar.jpg" className={classes.avatar} />
                                <Typography variant="h6" className={classes.userName}>{userData.accountName}</Typography>
                            </Box>
                            <List>
                                <ListItem className={classes.address}>
                                    <ListItemIcon>
                                        <LocationCity />
                                    </ListItemIcon>
                                    <ListItemText primary="City" secondary={userData.city} className={classes.labelName} />
                                </ListItem>
                                <ListItem className={classes.address}>
                                    <ListItemIcon>
                                        <LocationOn />
                                    </ListItemIcon>
                                    <ListItemText primary="State" secondary={userData.state} className={classes.labelName} />
                                </ListItem>
                                <ListItem className={classes.postalCode}>
                                    <ListItemIcon>
                                        <MailOutline />
                                    </ListItemIcon>
                                    <ListItemText primary="Postal Code" secondary={userData.zip} className={classes.labelName} />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>

        </>
    )
}

export default Home